import Carousel from 'react-bootstrap/Carousel';
import logo from '../assets/bg_logo.svg';
import './ScenarioBanner.less';
import busRoutesImg from '../assets/bus_routes.jpg';
import busStopsImg from '../assets/bus_stops.jpg';
import busTimeImg from '../assets/bus_time.jpg';


function ScenarioBanner() {
  return (
    <div className="scenario-banner">
    <Carousel fade className="scenario-banner-carousel">
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={busRoutesImg}
          alt="First slide"
        />
        <div className="carousel-overlay"></div>
        <Carousel.Caption>
          <h3>城市公車檢索</h3>
          <p>選取城市，便能一覽當地所有公車路線。<br/>
          輕鬆找到所需路線，方便出行。<br/>
          多樣選擇，滿足各種出行需求。
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={busStopsImg}
          alt="First slide"
        />
        <div className="carousel-overlay"></div>
        <Carousel.Caption>
          <h3>路線站點查詢</h3>
          <p>選取路線，便能一覽路線所有停靠站。<br/>
          瀏覽完整站點列表，便捷又快速。<br/>
          輕鬆查詢，享受愉快旅程。
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={busTimeImg}
          alt="First slide"
        />
        <div className="carousel-overlay"></div>
        <Carousel.Caption>
          <h3>預估抵達時間</h3>
          <p>
            選取路線，便能查看各站進站動態。<br/>
            查看每站抵達時間，方便規劃行程。<br/>
            即時更新，讓你掌握最新路線狀況。
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    </div>
  );
}

export default ScenarioBanner;